export enum ProjectSortColumn {
  account = "account",
  name = "name",
  csm = "csm",
  csta = "csta",
  begin = "begin",
  end = "end",
}
